import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/app/environments/environment.dev';
import { APIService } from '../api.service';
import { Constants } from '../../constants';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private userSubject: BehaviorSubject<null>;
    public user: Observable<null>;

    constructor(
        private router: Router,
        private _apiService: APIService
    ) {
        this.userSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('user')!));
        this.user = this.userSubject.asObservable();
    }

    public get userValue() {
        return this.userSubject.value;
    }

    login(username: string, password: string) {
        return this._apiService.post({ username, password }, `${environment.apiUrl}/users/authenticate`)
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            })).subscribe();
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('loginData');
        this.userSubject.next(null);
        this.router.navigate(['/login']);
    }
    getWorkerToken(sId: any, identity: any) {
        return this._apiService.post({ workerSid: sId, identity: identity }, Constants.elevator_call_URLS.workerToken + `?workerSid=${sId}`);
    }
    //API helper to get identity token for worker
    getIdentityToken(identity: any){
        return this._apiService.post({ identity: identity }, Constants.elevator_call_URLS.getIdentityToken+ `?identity=${identity}`)
    }
    updateUserActivity(userId: any, activityId: any, alarmId: any, incidentId: any, sender: any, countryId?: any) {
        // userId: userId, activityId: activityId, alarmId: alarmId, incidentId: incidentId, sender: sender, countryId: countryId
        let query = `?activityId=${activityId}&sender=${sender}&userId=${userId}`
        //Gopal--&countryId=${countryId}&alarmId=${alarmId}&incidentId=${incidentId}&
        //return this._apiService.post({userId: userId, activityId: activityId, alarmId: null, incidentId: null, sender: sender, countryId: countryId },Constants.elevator_call_URLS.updateUserActivity + query);
        return this._apiService.post({userId: userId, activityId: activityId, alarmId: null, incidentId: null, sender: sender, countryId: countryId },Constants.elevator_call_URLS.updateUserActivity + query);
    }
    updateActivity(data: any) {
        let query = `?SID=${data.sId}&actSId=${data.actSId}`
        return this._apiService.post(data, Constants.elevator_call_URLS.updateActivity+ query);
    }
    genRefreshToken(data: any) {
        if (data.loggedType != null || data.loggedType == '')
            ////data.loggedType = 'avaya';
            data.loggedType = '';
        return this._apiService.post(data, Constants.elevator_call_URLS.refreshToken + `?roleId=${data.roleId}&userId=${data.userId}`);
    }
    sendMailForUserAvailable(data: any){
        return this._apiService.post(data, Constants.elevator_call_URLS.sendEmailToSupervisor);
    }
    getStatusFromTwilio(data: any) {
        return this._apiService.post(data, Constants.elevator_call_URLS.getAgentStatusFromTwilio);
    }
}